import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueHiddenTitle: {
		id: 'software-flags.card-create-unmapped.issue-hidden-title',
		defaultMessage:
			'Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible',
		description: "Unmapped Issue's Status Title",
	},
	issueHiddenDescription: {
		id: 'software-flags.card-create-unmapped.issue-hidden-description',
		defaultMessage:
			'Issue {linkStart}{linkEnd} has a status that’s not visible on the board and backlog.',
		description: 'Unmapped Issues Status Description',
	},
	multipleIssuesHiddenDescription: {
		id: 'software-flags.card-create-unmapped.multiple-issues-hidden-description',
		defaultMessage:
			"{numIssues, plural, one {{numIssues} issue has} other {{numIssues} issues have}} been created, but one or more have a status that's not visible on the board and backlog",
		description: 'Unmapped Issues Status Description',
	},
	issueLink: {
		id: 'software-flags.card-create-unmapped.issue-link',
		defaultMessage: 'View {numIssues, plural, one {issue} other {issues}}',
		description: 'Link to the issue',
	},
	updatedIssueHiddenTitle: {
		id: 'software-flags.card-create-unmapped.updated-issue-hidden-title',
		defaultMessage:
			'Changes saved, but {numIssues, plural, one {Issue} other {Issues}} not visible',
		description: 'Title when the issue is not visible on board and backlog',
	},
	updatedIssueHiddenDescription: {
		id: 'software-flags.card-create-unmapped.updated-issue-hidden-description',
		defaultMessage:
			'For an issue to be visible, it must match your project and filters, and have a status that’s assigned to the board.',
		description: 'Description when the issue is not visible on board and backlog',
	},
	issueHiddenTitleIssueTermRefresh: {
		id: 'software-flags.card-create-unmapped.issue-hidden-title-issue-term-refresh',
		defaultMessage:
			'Changes saved, but {numIssues, plural, one {work item} other {work items}} not visible',
		description: "Unmapped Issue's Status Title",
	},
	issueHiddenDescriptionIssueTermRefresh: {
		id: 'software-flags.card-create-unmapped.issue-hidden-description-issue-term-refresh',
		defaultMessage:
			'Work item {linkStart}{linkEnd} has a status that’s not visible on the board and backlog.',
		description: 'Unmapped Issues Status Description',
	},
	multipleIssuesHiddenDescriptionIssueTermRefresh: {
		id: 'software-flags.card-create-unmapped.multiple-issues-hidden-description-issue-term-refresh',
		defaultMessage:
			"{numIssues, plural, one {{numIssues} work item has} other {{numIssues} work items have}} been created, but one or more have a status that's not visible on the board and backlog",
		description: 'Unmapped Issues Status Description',
	},
	issueLinkIssueTermRefresh: {
		id: 'software-flags.card-create-unmapped.issue-link-issue-term-refresh',
		defaultMessage: 'View {numIssues, plural, one {work item} other {work items}}',
		description: 'Link to the issue',
	},
	updatedIssueHiddenTitleIssueTermRefresh: {
		id: 'software-flags.card-create-unmapped.updated-issue-hidden-title-issue-term-refresh',
		defaultMessage:
			'Changes saved, but {numIssues, plural, one {work item} other {work items}} not visible',
		description: 'Title when the issue is not visible on board and backlog',
	},
	updatedIssueHiddenDescriptionIssueTermRefresh: {
		id: 'software-flags.card-create-unmapped.updated-issue-hidden-description-issue-term-refresh',
		defaultMessage:
			'For a work item to be visible, it must match your project and filters, and have a status that’s assigned to the board.',
		description: 'Description when the issue is not visible on board and backlog',
	},
});
